
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const getPayoutTable = createAsyncThunk("user/getPayoutTable", async (payload) => {
  const response = await api.post("user/get-payout-table", payload);
  
  return response.data;
});

const getPayoutTableSlice = createSlice({
  name: "user",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  extraReducers: (builder) => {
    builder
      .addCase(getPayoutTable.pending, (state) => {
        
        state.loading = true;
      })
      .addCase(getPayoutTable.fulfilled, (state, action) => {
      
       
        state.loading = false;
        state.data = action.payload.data.data;
      })
      .addCase(getPayoutTable.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default getPayoutTableSlice.reducer;
